import { Box } from "@mui/system";
import styled from "styled-components";

export const TabsStyled = styled(Box)`
  width: 100%;
  .MuiTabs-flexContainer {
    border-bottom: 1px solid #cfcfcf;
  }
  .MuiTab-root {
    text-transform: none;
    font-size: 12px;
    line-height: 18px;
    font-weight: 600;
    color: #000; 
    &:hover {
      color: ${(props) => "#2460B8"};
    }
  }
  .Mui-selected {
    color: ${(props) =>
      "#2460B8"} !important; 
    border-bottom: 2px solid ${(props) => "#2460B8"};
  }
  .MuiTabs-indicator {
    background-color: ${(props) => "#2460B8"};
  }
`;
